<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            @removeService="removeService"
        >
            <template #content>
                <ChangeBeforeAfter
                    v-if="showBlock.amount || showBlock.nt02Date || showBlock.closeCode"
                    title="投資設定"
                >
                    <template #before>
                        <div v-if="before.terminate">
                            <div class="text-sm md:text-lg">
                                未申請新台幣貨幣帳戶定期定額投資金額轉換
                            </div>
                        </div>
                        <div
                            v-else
                            class="pt-0.5 divide-y divide-dashed divide-gray-200"
                        >
                            <div
                                v-if="showBlock.amount"
                                class="grid grid-cols-2 md:grid-cols-4 dashed"
                            >
                                <div class="text-sm md:text-lg leading-6 xs:leading-7">
                                    投資金額
                                </div>
                                <div class="text-base xs:text-lg">
                                    {{ addComma(before.amount) }}
                                </div>
                            </div>
                            <div
                                v-if="showBlock.nt02Date"
                                class="grid grid-cols-2 md:grid-cols-4 dashed"
                            >
                                <div class="text-sm md:text-lg leading-6 xs:leading-7">
                                    指定轉換日
                                </div>
                                <div class="text-base xs:text-lg">
                                    <template v-if="before.nt02Date === 0">
                                        未指定
                                    </template>
                                    <template v-else>
                                        每月{{ before.nt02Date >= 10 ? before.nt02Date : '0' + before.nt02Date }}日
                                    </template>
                                </div>
                            </div>
                            <div
                                v-if="showBlock.closeCode && before.closeCode"
                                class="dashed"
                            >
                                <div class="text-sm md:text-base">
                                    若因辦理變更或基金交易中，致無法於指定轉換日進行轉換時，
                                    {{ before.closeCode=== '1' ? '將於變更或交易完成後之次一工作日，始進行轉換。': '' }}
                                    {{ before.closeCode=== '2' ? '將取消當月投資標的轉換，但不計入失敗次數。': '' }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <template #after>
                        <div v-if="after.terminate">
                            <div class="text-sm md:text-lg text-gray-900">
                                終止定期定額保費投資
                            </div>
                        </div>
                        <div
                            v-else
                            class="pt-0.5 divide-y divide-dashed divide-gray-200 text-gray-900"
                        >
                            <div
                                v-if="showBlock.amount"
                                class="grid grid-cols-2 md:grid-cols-4 dashed"
                            >
                                <div class="text-sm md:text-lg leading-6 xs:leading-7">
                                    投資金額
                                </div>
                                <div class="text-base xs:text-lg">
                                    {{ addComma(after.amount) }}
                                </div>
                            </div>
                            <div
                                v-if="showBlock.nt02Date"
                                class="grid grid-cols-2 md:grid-cols-4 dashed"
                            >
                                <div class="text-sm md:text-lg leading-6 xs:leading-7">
                                    指定轉換日
                                </div>
                                <div class="text-base xs:text-lg">
                                    <template v-if="after.nt02Date === 0">
                                        未指定
                                    </template>
                                    <template v-else>
                                        每月{{ after.nt02Date >= 10 ? after.nt02Date : '0' + after.nt02Date }}日
                                    </template>
                                </div>
                            </div>
                            <div
                                v-if="showBlock.closeCode && after.closeCode"
                                class="dashed"
                            >
                                <div class="text-sm md:text-base">
                                    若因辦理變更或基金交易中，致無法於指定轉換日進行轉換時，
                                    {{ after.closeCode=== '1' ? '將於變更或交易完成後之次一工作日，始進行轉換。': '' }}
                                    {{ after.closeCode=== '2' ? '將取消當月投資標的轉換，但不計入失敗次數。': '' }}
                                </div>
                            </div>
                        </div>
                    </template>
                </ChangeBeforeAfter>

                <ChangeBeforeAfter
                    v-if="showBlock.nt02ReinvestResultDataList"
                    title="配置比例"
                >
                    <template #before>
                        <div v-if="before.terminate">
                            <div class="text-sm md:text-lg">
                                無申請定期定額保費投資
                            </div>
                        </div>
                        <ul
                            v-else-if="before.nt02ReinvestResultDataList.length !==0"
                            class="divide-dashed divide-y -mr-2.5 md:-mr-4"
                        >
                            <li
                                v-for="(item, index) in before.nt02ReinvestResultDataList"
                                :key="index"
                                class="dashed flex item-baseline justify-between pr-2.5 md:pr-4 pl-0"
                            >
                                <div class="md:mr-4 w-4/5 flex-shrink-0">
                                    <span>
                                        {{ `${item.fundCode} ${item.fundName}` }}
                                    </span>
                                </div>
                                <div class="px-3 text-right w-16">
                                    <span>
                                        {{ `${item.percent}%` }}
                                    </span>
                                </div>
                            </li>
                        </ul>
                        <div v-else>
                            未配置
                        </div>
                    </template>
                    <template #after>
                        <div v-if="after.terminate">
                            <div class="text-sm md:text-lg text-gray-900">
                                終止定期定額保費投資
                            </div>
                        </div>
                        <ul
                            v-else-if="after.nt02ReinvestResultDataList.length !==0"
                            class="divide-dashed divide-y -mr-2.5 md:-mr-4"
                        >
                            <li
                                v-for="(item, index) in after.nt02ReinvestResultDataList"
                                :key="index"
                                class="dashed flex item-baseline justify-between pr-2.5 md:pr-4 pl-0 text-gray-900"
                            >
                                <div class="md:mr-4 w-4/5 md:flex-shrink-0">
                                    <span>
                                        {{ `${item.fundCode} ${item.fundName}` }}
                                    </span>
                                </div>
                                <div class="px-3 text-right w-16">
                                    <span>
                                        {{ `${item.percent}%` }}
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </template>
                </ChangeBeforeAfter>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef, computed } from 'vue';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ChangeBeforeAfter from '@/components/template/ChangeBeforeAfter.vue';
import { addComma } from '@/utils/number/addComma';
import { makeSort } from '@/utils/array/makeSort';

export default {
    name: 'A9Data',
    components: {
        CollapseConfirmData,
        ChangeBeforeAfter
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const code = ref('A9');
        const removeService = () => {
            emit('removeService', code.value);
        };
        const after = computed(() => data.value.after);
        const before = computed(() => data.value.before);

        /** 比對變更前後 只出現有變更的資料 */
        const showBlock = computed(() => {
            let nt02ReinvestListChange = false;
            if (after.value.nt02ReinvestResultDataList.length === before.value.nt02ReinvestResultDataList.length !== 0) {
                const afterlist = makeSort(after.value.nt02ReinvestResultDataList, 'fundCode');
                const beforelist = makeSort(before.value.nt02ReinvestResultDataList, 'fundCode');
                nt02ReinvestListChange = JSON.stringify(afterlist) !== JSON.stringify(beforelist);
            } else {
                nt02ReinvestListChange = true;
            }
            const change = {
                amount: after.value.amount !== before.value.amount,
                nt02Date: after.value.nt02Date !== before.value.nt02Date,
                closeCode: after.value.closeCode !== before.value.closeCode,
                nt02ReinvestResultDataList: nt02ReinvestListChange,
            };
            return change;
        });
        return {
            code,
            showBlock,
            data,
            after,
            before,
            addComma,
            removeService,
        };
    },
};
</script>
<style lang="scss" scoped>
.dashed {
    @apply pt-1 pb-1 first:pt-0 last:pb-0.5;
}
</style>
